export default "__VITE_ASSET__b8f9ab65__"